import { Component, Input, Output, EventEmitter } from '@angular/core';

import { GradeDetails, GradeType } from 'src/app/domain';
import { IonicModule } from '@ionic/angular';
import { GradeTimesReceivedComponent } from '../grade-times-received/grade-times-received.component';
import { GradeRangeComponent } from '../grade-range/grade-range.component';
import { TitleCasePipe } from '@angular/common';

@Component({
    selector: 'app-grade',
    templateUrl: './grade.component.html',
    styleUrls: ['./grade.component.scss'],
    imports: [IonicModule, GradeTimesReceivedComponent, GradeRangeComponent, TitleCasePipe]
})
export class GradeComponent {
  @Input() grade: GradeDetails;
  @Input() mobile = false;
  @Input() currentStep: number;
  @Input() gradeType: GradeType;
  @Input() gradeList: GradeDetails[];
  @Input() validGrades: boolean;
  @Output() deleteGrade = new EventEmitter();
  type = GradeType;

  deleteRow(): void {
    this.deleteGrade.emit(this.grade.name);
  }
  selectedTimesAchieved(timesAchieved: number): void {
    this.grade.timesAchieved = timesAchieved;
  }
}
